import React, { FC } from 'react';

import { Svg, SvgProps } from '@lglp/components';

import styles from './Error404Icon.module.scss';

const Error404Icon: FC<Error404IconProps> = ({ className, ...rest }) => {
  return (
    <Svg
      viewBox="0 0 516 279.566"
      className={[styles.error404Icon, className]}
      {...rest}
    >
      <g transform="translate(2 2)">
        <text className={styles.text} transform="translate(435 209)">
          <tspan x="-76.896" y="0">
            4
          </tspan>
        </text>
        <path
          fill="#215382"
          stroke="#215382"
          strokeWidth="0.5px"
          d="M7.158 214.731l63.018-63.608a89.807 89.807 0 1 1 13.63 13.807L21.2 228.125a9.7 9.7 0 0 1-13.689.354 9.762 9.762 0 0 1-.353-13.748zM140.747 165.7a70.913 70.913 0 1 0-50.155-20.77 70.476 70.476 0 0 0 50.155 20.77z"
          transform="translate(116.973 46.182)"
        />
        <text className={styles.text} transform="translate(77 209)">
          <tspan x="-76.896" y="0">
            4
          </tspan>
        </text>
      </g>
    </Svg>
  );
};

type Error404IconProps = SvgProps;

export default Error404Icon;
